var _circle, _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 73,
    viewBox: "0 0 104 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.1172,
    cy: 36.5,
    r: 36.266,
    fill: "url(#paint0_linear_506_3270)",
    stroke: "#81A9D7",
    strokeWidth: 0.467949
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6337 21.6545C77.7066 21.612 77.7802 21.569 77.8546 21.5256C78.4789 21.1614 79.084 20.8454 79.6724 20.5751C82.3851 25.2587 83.9379 30.698 83.9379 36.5C83.9379 54.074 69.6914 68.3205 52.1174 68.3205C34.5434 68.3205 20.2969 54.074 20.2969 36.5C20.2969 31.6712 21.3725 27.0936 23.2972 22.9937C23.6284 23.1038 23.9552 23.2148 24.2784 23.3245C28.45 24.7409 32.0198 25.953 36.6751 22.4615C44.1623 16.8461 53.0533 17.3141 61.9443 21.5256C70.7263 25.6855 71.7669 25.0782 77.6337 21.6545Z",
    fill: "url(#paint1_linear_506_3270)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_506_3270)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.1172,
    cy: 35.5,
    rx: 41.5,
    ry: 16.5,
    fill: "#B0FF4A",
    fillOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6292 34.14H55.4132V35.364H51.2132V36.06C51.1892 36.788 51.1452 37.392 51.0812 37.872H56.3612V39.084H52.7732V42.804C52.7732 43.196 52.9532 43.392 53.3132 43.392H54.5972C54.8132 43.392 54.9772 43.304 55.0892 43.128C55.2172 42.968 55.3052 42.428 55.3532 41.508L56.5292 41.904C56.4252 43.2 56.2372 43.968 55.9652 44.208C55.7172 44.44 55.3412 44.556 54.8372 44.556H52.9292C51.9932 44.556 51.5252 44.056 51.5252 43.056V39.084H50.8772C50.6532 40.124 50.3492 41.008 49.9652 41.736C49.2212 43.056 48.0212 44.064 46.3652 44.76L45.6572 43.644C47.2972 42.892 48.4092 41.948 48.9932 40.812C49.2252 40.3 49.4212 39.724 49.5812 39.084H45.8612V37.872H49.7972C49.8692 37.296 49.9172 36.692 49.9412 36.06V35.364H46.6292V34.14Z",
    fill: "#112C56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_506_3270",
    x: 0.135136,
    y: 8.51795,
    width: 103.964,
    height: 53.9641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.24103,
    result: "effect1_foregroundBlur_506_3270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_506_3270",
    x1: 52.1172,
    y1: 0,
    x2: 52.1172,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10234E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16547B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_506_3270",
    x1: 83.9379,
    y1: 36.868,
    x2: 20.2969,
    y2: 36.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EC80C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491939,
    stopColor: "#D3FF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC80C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.7c1172cbc8e3eed82c613013b645dbbf.svg";
export { ForwardRef as ReactComponent };